import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import { ControlSeverityMssp } from "../../../../utils/constants";
import { getSeverityColor } from "./utils";

const SeverityLegend = () => {
  const colors = useColors();
  const severityLegend = [
    {
      label: "High",
      color: getSeverityColor(ControlSeverityMssp.HIGH, colors),
    },
    {
      label: "Medium",
      color: getSeverityColor(ControlSeverityMssp.MEDIUM, colors),
    },
    {
      label: "Low",
      color: getSeverityColor(ControlSeverityMssp.LOW, colors),
    },
    {
      label: "Compliant",
      color: getSeverityColor(ControlSeverityMssp.COMPLIANT, colors),
    },
    {
      label: "Not Deployed",
      color: getSeverityColor(ControlSeverityMssp.NOT_DEPLOYED, colors),
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
      {severityLegend.map((item) => (
        <Box
          key={item.label}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "3px",
              backgroundColor: item.color,
            }}
          />
          <Typography
            variant="caption"
            sx={{
              color: colors.text_secondary,
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default SeverityLegend;
